import axios from "axios";

import {
  APP_VERSION_URL,
  APP_VERSION_FETCH_TIMEOUT_MS,
} from "../constants/appVersion";
import { ENABLE_APP_VERSION_LOGS } from "../constants/logging";

const log = (...args: unknown[]) => {
  if (!ENABLE_APP_VERSION_LOGS) return;
  // eslint-disable-next-line no-console
  console.log("[appVersionApi]", ...args);
};

export interface PlatformVersionInfo {
  latest: string;
  minimum: string;
  storeUrl: string;
  appId: string;
  useNativeMarket: boolean;
}

export interface AppVersionConfig {
  ios: PlatformVersionInfo;
  android: PlatformVersionInfo;
}

// One-shot client. No interceptors, no retries — the caller decides what
// to do on failure (use cache, fall back to "ok").
//
// `Cache-Control: no-cache` request header forces revalidation against
// CloudFront on every fetch. Without it, the CDN response (which today
// ships no `Cache-Control` from S3) is cached heuristically by the
// platform's HTTP layer (URLSession on iOS, OkHttp on Android), leading
// to stale config — users see an old `latest`/`minimum` for hours after
// ops updates the JSON. CloudFront's own TTL still throttles origin
// hits; the freshness cost is bounded.
//
// Cache-busting query param is a belt-and-suspenders fallback for
// environments that ignore the request header.
export const fetchAppVersionConfig = async (): Promise<AppVersionConfig> => {
  log("fetch start", { url: APP_VERSION_URL });
  try {
    const response = await axios.get<AppVersionConfig>(APP_VERSION_URL, {
      timeout: APP_VERSION_FETCH_TIMEOUT_MS,
      headers: {
        "Cache-Control": "no-cache",
      },
      params: { ts: Date.now() },
    });
    log("fetch success", {
      status: response.status,
      headers: response.headers,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    log("fetch error", error);
    throw error;
  }
};
